export const ANSWER_VALIDATION_SPINNER = 'ANSWER_VALIDATION_SPINNER';
export const FINISH_SPINNER = 'FINISH_SPINNER';
